import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, combineLatest, of } from 'rxjs';
import { map, flatMap, switchAll } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { LabTestResultsReadModel, LabTestResult } from './lab-test-result';
import { Settings } from '../core/settings';
import { Site } from '../sites/site';
import { uniqBy } from 'lodash';
import { getOptionalParametersForSTRQuery } from '../on-screen-results/standard-test-results/standart-test-result-query-parameters';

@Injectable()
export class LabResultsStorage {
    constructor(
        private readonly settings: Settings,
        private readonly http: HttpClient,
        private readonly route: ActivatedRoute
    ) { }

    public getSubjectLabResults(selectedSite: Observable<Site>, selectedCtSubjectId: Observable<number>): Observable<LabTestResult[]> {
        return combineLatest(
            [selectedSite,
            selectedCtSubjectId]
        ).pipe(
            map(([site, ctSubjectId]: [Site, number]) => this.http.get(`${this.settings.apiUrl}/sites/${site.siteId}/subjects/${ctSubjectId}/lab-test-results`)
                .pipe(map((response) => deserialize(response, LabTestResultsReadModel).results))),
            flatMap((x) => of(of(null), x)),
            switchAll()
        );
    }

    public getSiteLabResultsRestricted(selectedSite: Observable<Site>, loadAll$: Observable<boolean>): Observable<LabTestResult[]> {
        return combineLatest([selectedSite, loadAll$])
            .pipe(
                map(([site, loadAll]: [Site, boolean]) => {
                    const optionalParams = getOptionalParametersForSTRQuery(loadAll, site, this.route.snapshot.queryParams);

                    return this.http
                        .get(`${this.settings.apiUrl}/sites/${site.siteId}/lab-test-results${optionalParams}`)
                        .pipe(
                            map((response) => {
                                const results = deserialize(response, LabTestResultsReadModel).results;
                                const subjects = uniqBy(results, r => r.ctSubjectId).map(r => r.ctSubjectId);
                                results.forEach((r, i) => r.subjectSerialNumber = subjects.indexOf(r.ctSubjectId));
                                return results;
                            }));
                        }
                ),
                flatMap((x) => of(of(null), x)),
                switchAll());
    }
}
